import Vue from 'vue'
import VueRouter from 'vue-router'

import HomeView from '../views/HomeView.vue'
import ApresentacaoView from '../views/ApresentacaoView.vue'
import PrazerFAPESPView from '../views/PrazerFAPESPView.vue'
import LinhaTempoView from '../views/LinhaTempoView.vue'

import FasciculosView from '../views/FasciculosView.vue'
import SinglePostView from '../views/SinglePostView.vue'
import SingleIssueView from '../views/SingleIssueView.vue'

import SingleExecSumView from '../views/SingleExecSumView.vue'
import ExecSumView from '../views/ExecSumView.vue'
import IndicatorsAll from '../views/IndicatorsAll.vue'

import Prefacio from '../views/PrefacioView.vue'




Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/apresentacao',
    name: 'Apresentação',
    component: ApresentacaoView
  },
  {
    path: '/muito-prazer-fapesp',
    name: 'Muito prazer, FAPESP',
    component: PrazerFAPESPView
  },
  {
    path: '/linha-do-tempo',
    name: 'Linha do Tempo',
    component: LinhaTempoView
  },
  {
    path: '/fasciculos',
    name: 'FasciculosView',
    component: FasciculosView,
    props: true
  },
  {
    path: '/resumo-executivo/indicadores',
    name: 'IndicatorsAll',
    component: IndicatorsAll,
    // props: true
  },
  {
    path: '/resumo-executivo/prefacio',
    name: 'Prefacio',
    component: Prefacio,
    // props: true
  },
  {
    path: '/resumo-executivo',
    name: 'ExecSumView',
    component: ExecSumView,
    // props: true
  },
  {
    path: '/resumo-executivo/:idx/:slug',
    name: 'SingleExecSumView',
    component: SingleExecSumView,
    // props: true
  },
  {
    path: '/:slug',
    name: 'SingleIssueView',
    component: SingleIssueView,
    props: true
  },
  {
    path: '/:issue/:slug',
    name: 'SinglePostView',
    component: SinglePostView,
    props: true
  },


]

const router = new VueRouter({
  // mode: 'history',

  // base: process.env.BASE_URL,
  base: process.env.NODE_ENV === 'production'
    ? '/livro/'
    : '/',
  routes
})

export default router
